import { ContentBlock, Box, Stack, Heading } from 'braid-design-system';
import React, { type FC, type ReactNode } from 'react';

import { Error400Image } from './Error400Image';
import { Error500Image } from './Error500Image';

export interface ErrorContentProps {
  errorCode: '400' | '500';
  heading: string;
  body?: ReactNode;
}

const errorCodeMap: Record<ErrorContentProps['errorCode'], JSX.Element> = {
  '400': <Error400Image />,
  '500': <Error500Image />,
};

export const ErrorContent: FC<ErrorContentProps> = ({
  errorCode,
  heading,
  body,
}) => (
  <ContentBlock width="small">
    <Box paddingY={['none', 'xxlarge']}>
      <Box
        background="surface"
        paddingY={['xxlarge', 'xlarge']}
        paddingX="gutter"
      >
        <Stack space="gutter" align="center">
          {errorCodeMap[errorCode]}
          <Heading level="3" align="center">
            {heading}
          </Heading>
          {body ? <>{body}</> : null}
        </Stack>
      </Box>
    </Box>
  </ContentBlock>
);
